export default __webpack_public_path__ + "static/image154-3a8b774f0211db3a7a24dc0b77a41c71.jpg";